import { Link } from "react-router-dom";
import * as S from "./notFound.styles";
function PageNotFound() {
  return (
    <S.Wrraper>
      <div>
        <S.Title>کجا میخواستی بری ؟</S.Title>
      </div>
      <div style={{ margin: "2rem 0rem" }}>
        <img src="/images/Asset 3.png" width={"100%"} alt="404" />
      </div>
      <div>
        <S.BtnHome as={Link} to={"/"}>
          برگشت به صفحه اصلی
        </S.BtnHome>
      </div>
    </S.Wrraper>
  );
}
export default PageNotFound;
